import { Box, Stack } from '@mui/material';
import React from 'react';

import { NextPaymentDueResponse } from '../IMessageBubbleInterface';
import { formatCurrency } from '../MessageBubbleHelpers';

import { BadgePill, CardFollowUp, CardHeaderRow, CardIntro, CardShell, MetricTile } from './sharedCardHelpers';

export const NextPaymentDueCard: React.FC<{ nextPaymentDue: NextPaymentDueResponse | null }> = ({ nextPaymentDue }) => {
    if (!nextPaymentDue) return null;

    const formatPaymentAmount = (value: string) => {
        const trimmed = (value || '').trim();
        if (!trimmed) {
            return '-';
        }
        // Render as currency when it parses to a number; otherwise show the raw value.
        return /\d/.test(trimmed) ? formatCurrency(trimmed) : trimmed;
    };

    return (
        <Box>
            <CardIntro text={nextPaymentDue.intro} />

            <Stack gap={0.9}>
                {nextPaymentDue.items.map((item, itemIdx) => (
                    <CardShell key={`${item.contractId}-${itemIdx}`}>
                        <CardHeaderRow
                            contractId={item.contractId}
                            right={item.frequency ? <BadgePill>{item.frequency}</BadgePill> : undefined}
                        />

                        <Box
                            sx={{
                                p: 0.9,
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
                                gap: 0.7,
                            }}
                        >
                            <MetricTile label="NEXT PAYMENT DATE" value={item.nextPaymentDate || '-'} />
                            <MetricTile label="AMOUNT DUE" value={formatPaymentAmount(item.nextPaymentAmount)} />
                        </Box>
                    </CardShell>
                ))}
            </Stack>

            <CardFollowUp text={nextPaymentDue.followUp} />
        </Box>
    );
};
